import { ALGORITHMS_ERROR } from '@client';
import { ActionTag } from './action-tag';
import StatusTagMenu from '@/components/StatusTagMenu';

interface ActionTagsProps {
  clientTags: string[];
  client: Client;
}

export function ActionTags({ clientTags, client }: ActionTagsProps) {
  return (
    <div className="flex flex-wrap">
      {clientTags.map(clientTag => {
        if (!clientTag) return null;
        return (
          <ActionTag
            key={clientTag}
            clientTag={clientTag}
            client={client}
          />
        );
      })}
      {clientTags[0] === ALGORITHMS_ERROR ? null : (
        <StatusTagMenu clientTags={clientTags} client={client} />
      )}
    </div>
  );
}
